import { useInfiniteQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import { ACTIVE_RUN_POLL_MS, isRunActive, type RunScope } from "./types";

/** Shared by the runs section and the panel host that waits on the first page
 * before revealing the panel; identical options let React Query dedupe. */
export function useRunHistory({
  scope,
  enabled = true,
}: {
  scope: RunScope;
  enabled?: boolean;
}) {
  const trpc = useTRPC();
  const listOptions = trpc.psv.listRuns.infiniteQueryOptions(scope, {
    getNextPageParam: (page) => page.nextCursor ?? undefined,
  });
  return useInfiniteQuery({
    ...listOptions,
    enabled,
    refetchInterval: (query) =>
      query.state.data?.pages.some((page) => page.runs.some(isRunActive))
        ? ACTIVE_RUN_POLL_MS
        : false,
  });
}
